import { createAsyncThunk } from "@reduxjs/toolkit";
import { showSnackbar } from "../../snackbar/Snackbar.slice";
import { get, del } from "../../../services/apiService";

const INVOICES_LIST = "invoices/list";
const INVOICES_DELETE = "invoices/delete";

export const getInvoicesList = createAsyncThunk(
  INVOICES_LIST,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const {
        token,
        page = 1,
        page_size = 5,
        client_info_id,
        status_filter,
        search,
      } = payload;

      if (!client_info_id) {
        throw new Error("Client Info ID is required");
      }

      const url = "/invoices";
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          page_size,
          client_info_id,
          ...(status_filter && { status: status_filter }),
          ...(search && { search }),
        },
      };

      const result = await get(url, config);

      return {
        invoicesList: result.data || [],
        page: result.page || page,
        page_size: result.page_size || page_size,
        total_pages: result.total_pages || 0,
        total_records: result.total_records || 0,
      };
    } catch (error) {
      console.error("Error getting invoices list thunk:", error);
      dispatch(
        showSnackbar({
          message:
            error.response?.data?.detail ||
            error.message ||
            "Error loading invoices information",
          severity: "error",
        })
      );
      return rejectWithValue({
        message:
          error.response?.data?.detail ||
          error.message ||
          "Error loading invoices information",
      });
    }
  }
);

export const deleteInvoice = createAsyncThunk(
  INVOICES_DELETE,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { token, invoiceId, page, page_size, client_info_id, search } = payload;
      const url = `/invoices/${invoiceId}`;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      await del(url, config);

      dispatch(
        showSnackbar({
          message: "Invoice cancelled successfully",
          severity: "success",
        })
      );

      // Reload the list after deletion
      if (client_info_id) {
        dispatch(
          getInvoicesList({
            token,
            page,
            page_size,
            client_info_id,
            search,
          })
        );
      }

      return { id: invoiceId };
    } catch (error) {
      console.error("Error deleting invoice thunk:", error);
      dispatch(
        showSnackbar({
          message:
            error.response?.data?.detail ||
            error.message ||
            "Error cancelling invoice",
          severity: "error",
        })
      );
      return rejectWithValue({
        message:
          error.response?.data?.detail ||
          error.message ||
          "Error cancelling invoice",
      });
    }
  }
);
